import * as vp from 'vopay';
import { FunctionComponent, useEffect } from 'react';
import { useClientLogin } from '../../../providers/ClientLogin.provider';

const { Box, useCookie } = vp;

type FC = FunctionComponent;

const AuthUser: FC = () => {
  const { getCookie, deleteCookie } = useCookie();
  const { switchUser, handleLoginUsername } = useClientLogin();
  useEffect(() => {
    const token = getCookie(vp.LS_DASHBOARD_TOKEN) || '';
    const username = getCookie(vp.LS_DASHBOARD_USERNAME) || '';
    handleLoginUsername(username);
    switchUser({
      JWToken: token,
    });
    deleteCookie(vp.LS_DASHBOARD_TOKEN);
    deleteCookie(vp.LS_DASHBOARD_USERNAME);
  }, []);

  return (
    <>
      <Box flx="col" />
    </>
  );
};

export default AuthUser;
